import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../core/modules/common/components/Modal';

const LegendModal = (props) => {
  const {
    closeChart,
  } = props;

  return (
    <div className="chart-modal">
      <Modal
        closeOnOutsideClick
        onClose={closeChart}
      >
        <div className="chart-modal__wrapper" style={{ height: '200px' }}>
          <table>
            <thead>
              <tr>
                <th style={{ fontWeight: 'bold', borderRight: '1px solid rgba(0, 0, 0, 0.1)' }}>Status *</th>
                <th style={{ fontWeight: 'bold' }}>Font format</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ backgroundColor: 'rgba(0, 0, 0, 0.03)' }}>
                <td style={{ borderRight: '1px solid rgba(0, 0, 0, 0.1)' }}>Denested</td>
                <td style={{ color: '#7DBD7B' }}>FRCDGABEBRU</td>
              </tr>
              <tr>
                <td style={{ borderRight: '1px solid rgba(0, 0, 0, 0.1)' }}>Not denested</td>
                <td style={{ color: '#D20020' }}>FRCDGABEBRU</td>
              </tr>
              <tr style={{ backgroundColor: 'rgba(0, 0, 0, 0.03)' }}>
                <td style={{ borderRight: '1px solid rgba(0, 0, 0, 0.1)' }}>Excluded Denested</td>
                <td style={{ color: '#7DBD7B', textDecoration: 'line-through' }}>FRCDGABEBRU</td>
              </tr>
              <tr>
                <td style={{ borderRight: '1px solid rgba(0, 0, 0, 0.1)' }}>Excluded Not Denested</td>
                <td style={{ color: '#D20020', textDecoration: 'line-through' }}>FRCDGABEBRU</td>
              </tr>
              <tr style={{ backgroundColor: 'rgba(0, 0, 0, 0.03)' }}>
                <td style={{ borderRight: '1px solid rgba(0, 0, 0, 0.1)' }}>Duplicate</td>
                <td style={{ textDecoration: 'line-through' }}>FRCDGABEBRU</td>
              </tr>
              <tr>
                <td style={{ borderRight: '1px solid rgba(0, 0, 0, 0.1)' }}>NEST START</td>
                <td style={{ backgroundColor: '#C6E0B4' }}>FRCDGABEBRU</td>
              </tr>
              <tr style={{ backgroundColor: 'rgba(0, 0, 0, 0.03)' }}>
                <td style={{ borderRight: '1px solid rgba(0, 0, 0, 0.1)' }}>NEST STOP</td>
                <td style={{ backgroundColor: '#FCE4D6' }}>FRCDGABEBRU</td>
              </tr>
              <tr>
                <td style={{ borderRight: '1px solid rgba(0, 0, 0, 0.1)' }}>Unused MRD label</td>
                <td style={{ color: '#4a90e2', fontWeight: 'bold' }}>FRCDGABEBRU</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Modal>
    </div>
  );
};


LegendModal.propTypes = {
  closeChart: PropTypes.func.isRequired,
};

export default LegendModal;
